import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { siteContent } from "@/data/site-content";
import SectionRenderer from "@/components/sections/SectionRenderer";
import Layout from "@/components/layout/Layout";
import { Seo } from "@/components/Seo";

const DynamicPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const page = siteContent.pages.find((p) => p.slug === slug);
  const seo = slug ? siteContent.seo[slug] : undefined;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!page) {
    return (
      <Layout>
        <Seo title="Siden ble ikke funnet – Håp Naturlab" description="404" noIndex />
        <div className="flex min-h-[60vh] items-center justify-center">
          <div className="text-center">
            <h1 className="text-4xl font-bold">404</h1>
            <p className="mt-4 text-muted-foreground font-body">
              Siden ble ikke funnet.
            </p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      {seo && (
        <Seo title={seo.title} description={seo.description} path={slug} />
      )}
      <SectionRenderer sections={page.sections} />
    </Layout>
  );
};

export default DynamicPage;
